import { createContext } from 'react';

import { HistogramChartTooltipConfig } from '../types/histogram.js';

export const HistogramTooltipContext =
  createContext<HistogramChartTooltipConfig>({
    variant: 'single',
  });
